import { Box, useMediaQuery, Typography } from '@mui/material'
import LandingPageCarousel from 'components/smart/Carousel/LandingPageCarousel'
import Quotes from '../assets/landingpage_testimonal_quote.png'

const Testimonial = () => {
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'))
  const testimonialArray = [
    {
      userOne: {
        name: 'Muhammad Fairuz',
        age: 24,
        testimonial: `The SEC bootcamp was a transformative journey that pushed my limits and sharpened my web development skills. I'm much more confident in my web development skills now, and I'm excited to tackle more challenging projects and continue growing in the field. The program has proven to be valuable as I have successfully landed my first software engineer role at a company.`,
        jobscope: 'Software Engineer',
      },
      userTwo: {
        name: 'Jun Yang Chin',
        age: 26,
        testimonial: `The program was designed in a way that it fast tracked learning while still providing in-depth knowledge of the subject, making it easy for learners to quickly grasp the essential concepts of software engineering. I am deeply grateful for the experience and wholeheartedly recommend the SEC bootcamp to anyone seeking to break into the field of software engineering.`,
        jobscope: 'Software Engineer',
      },
    },
    {
      userOne: {
        name: 'Muhammad Naqib',
        age: 27,
        testimonial: `The Data Science Bootcamp enabled me to work a 9-5 job and still attend classes at night
            and live consultations on weekends. The online classes are engaging and the trainer, Dr.
            Nickholas is qualified, enthusiastic and supportive. It was worth investing my time for
            2 months because at the end of it, I felt confident in applying for data science jobs in
            Malaysia`,
        jobscope: 'Data Scientist',
      },
      userTwo: {
        name: 'Wan Adzhar Faiq',
        age: 27,
        testimonial: `I took the course because I wanted the option to pivot my career into Data Science. I
          have no regrets as this course provided me with the practical experience and portfolio
          building, allowing me to qualify as a data scientist in the real job market. Dr
          Nickholas is very helpful and has patiently gone through application of key concepts
          with us. The curriculum is well-planned and covers basic and advanced concepts in data
          science. I am now hired as data scientist at Invoke`,
        jobscope: 'Data Scientist',
      },
    },
  ]
  return (
    <LandingPageCarousel
      arrowIndicator={isLarge && true}
      bottomIndicator={false}
      refId={'testimony'}
      timer={8000}
      infinite
    >
      {testimonialArray.map((item, index) => {
        const { userOne, userTwo } = item
        return (
          <Box key={index} sx={{ display: 'flex', flexDirection: isLarge ? 'row' : 'column', columnGap: 10 }}>
            <Box
              sx={{
                backgroundColor: '#FEF7D9',
                width: '100%',
                height: '100%',
                p: '20px',
                borderRadius: '4.5px',
              }}
            >
              <Box sx={{ mb: '20px' }}>
                <img alt='' className='w-[25px] h-[25px]' src={Quotes} />
              </Box>
              <Typography variant="body1" sx={{ mb: '30px' }}>
                {userOne?.testimonial}
              </Typography>
              <Typography variant="subtitle1">
                {userOne?.name} ({userOne?.age})
              </Typography>
              <Typography variant="body2" sx={{ color: 'light-gray-text.main' }}>
                {userOne?.jobscope}
              </Typography>
            </Box>
            <Box
              sx={{
                backgroundColor: '#FEF7D9',
                width: '100%',
                height: '100%',
                p: '20px',
                borderRadius: '4.5px',
              }}
            >
              <Box sx={{ mb: '20px' }}>
                <img alt='' className='w-[25px] h-[25px]' src={Quotes} />
              </Box>
              <Typography variant="body1" sx={{ mb: '30px' }}>
                {userTwo?.testimonial}
              </Typography>
              <Typography variant="subtitle1">
                {userTwo?.name} ({userTwo?.age})
              </Typography>
              <Typography variant="body2" sx={{ color: 'light-gray-text.main' }}>
                {userTwo?.jobscope}
              </Typography>
            </Box>
          </Box>
        )
      })}
    </LandingPageCarousel>
  )
}

export default Testimonial
